import { forwardRef, SyntheticEvent } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps, AlertColor } from "@mui/material/Alert";

export type NotificationType = {
  type: AlertColor;
  message: string;
};

interface NotificationProps {
  notification: NotificationType;
  setNotification: (notification: NotificationType) => void;
  autoHideDuration?: number | null;
}

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Notification({
  notification,
  setNotification,
  autoHideDuration = 6000,
}: NotificationProps) {
  const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setNotification({ ...notification, message: "" });
  };

  return (
    <Snackbar
      open={notification.message !== ""}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={handleClose}
        severity={notification.type}
        sx={{ width: "100%" }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
}
